import React from "react";
import { Modal, ModalBody, ModalFooter, Button } from "reactstrap";

const DeleteModal = ({ isOpen, toggle, onDelete, title = "Delete?" }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalBody className="text-center p-4 addresources_bottom_form">
        <h5 className="text-white mb-3">{title}</h5>
        <p style={{ color: "#ccc" }}>
          Are you sure you want to delete this item? This action cannot be
          undone.
        </p>
      </ModalBody>

      <ModalFooter
        style={{ background: "#201d35" }}
        className="d-flex justify-content-center gap-3 pb-4 addresources_bottom_form"
      >
        <Button
          className="export_csv"
          color="danger"
          style={{ minWidth: 120, height: 45 }}
          onClick={onDelete}
        >
          Delete
        </Button>

        <Button
          className="export_csv"
          color="secondary"
          style={{ minWidth: 120, height: 45 }}
          onClick={toggle}
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteModal;
